import { render } from "./inicio.vue?vue&type=template&id=21ff2395&scoped=true"
import script from "./inicio.vue?vue&type=script&lang=js"
export * from "./inicio.vue?vue&type=script&lang=js"

import "./inicio.vue?vue&type=style&index=0&id=21ff2395&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21ff2395"

export default script